import {
    DefinedLocation,
    DefinedLocationLinkedLocation,
    DefinedLocationMetadata,
    DefinedLocationVersionEntry,
} from "../../models/defined-location";

type RawDefinedLocation = Omit<DefinedLocation, "LocationId" | "Version" | "LinkedLocations" | "Versions"> & {
    LocationId: number;
};

const rawDefinedLocations: RawDefinedLocation[] = [
        {
            "ONRSRRef": 504157,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 1",
            "LocationId": 732476,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 656940,
            "IsExpanded": true,
            "LinkItemId": 705967,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 691113,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 2",
            "LocationId": 501710,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 946039,
            "IsExpanded": true,
            "LinkItemId": 151875,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 860168,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 6,
            "StateLabel": "Western Australia",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 3",
            "LocationId": 106563,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 503926,
            "IsExpanded": true,
            "LinkItemId": 816171,
            "ValidationStatus": "Closed"
        },
        {
            "ONRSRRef": 784136,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 2,
            "StateLabel": "Northern Territory",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 6,
            "DefinedLocationTypeName": "Control point",
            "LocationName": "Control point 4",
            "LocationId": 997224,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 756268,
            "IsExpanded": true,
            "LinkItemId": 307121,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 290281,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId":3,
            "StateLabel": "Victoria",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 5",
            "LocationId": 209408,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 891636,
            "IsExpanded": true,
            "LinkItemId": 257518,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 863407,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 6",
            "LocationId": 645666,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 949936,
            "IsExpanded": false,
            "LinkItemId": 631407,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 172207,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 7",
            "LocationId": 269719,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 349382,
            "IsExpanded": true,
            "LinkItemId": 615078,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 386102,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 2,
            "StateLabel": "Northern Territory",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 6,
            "DefinedLocationTypeName": "Control point",
            "LocationName": "Control point 8",
            "LocationId": 309240,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 756396,
            "IsExpanded": true,
            "LinkItemId": 863672,
            "ValidationStatus": "Delete Requested"
        },
        {
            "ONRSRRef": 838842,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 5,
            "StateLabel": "Queensland",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 4,
            "DefinedLocationTypeName": "Station",
            "LocationName": "Station 9",
            "LocationId": 707367,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 871651,
            "IsExpanded": false,
            "LinkItemId": 650957,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 211799,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 4,
            "StateLabel": "Australian Capital Territory",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId":3,
            "DefinedLocationTypeName": "Crossing Loop",
            "LocationName": "Crossing Loop 10",
            "LocationId": 487844,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 144256,
            "IsExpanded": false,
            "LinkItemId": 567082,
            "ValidationStatus": "Closed"
        },
        {
            "ONRSRRef": 452448,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 2,
            "StateLabel": "Northern Territory",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 6,
            "DefinedLocationTypeName": "Control point",
            "LocationName": "Control point 11",
            "LocationId": 835554,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 517588,
            "IsExpanded": false,
            "LinkItemId": 238977,
            "ValidationStatus": "Pending Validation"
        },
        {
            "ONRSRRef": 626525,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 6,
            "StateLabel": "Western Australia",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 12",
            "LocationId": 972659,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 925520,
            "IsExpanded": false,
            "LinkItemId": 554904,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 165854,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 2,
            "StateLabel": "Northern Territory",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 13",
            "LocationId": 152477,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 959158,
            "IsExpanded": false,
            "LinkItemId": 575439,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 305817,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId":3,
            "DefinedLocationTypeName": "Crossing Loop",
            "LocationName": "Crossing Loop 14",
            "LocationId": 173612,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 203149,
            "IsExpanded": true,
            "LinkItemId": 494731,
            "ValidationStatus": "Pending Validation"
        },
        {
            "ONRSRRef": 836959,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 5,
            "StateLabel": "Queensland",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 15",
            "LocationId": 383567,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 640082,
            "IsExpanded": false,
            "LinkItemId": 374504,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 424592,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 16",
            "LocationId": 108579,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 613659,
            "IsExpanded": true,
            "LinkItemId": 273035,
            "ValidationStatus": "Delete Requested"
        },
        {
            "ONRSRRef": 984624,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 17",
            "LocationId": 129859,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 640899,
            "IsExpanded": true,
            "LinkItemId": 198505,
            "ValidationStatus": "Delete Requested"
        },
        {
            "ONRSRRef": 971194,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 5,
            "DefinedLocationTypeName": "Private siding",
            "LocationName": "Private siding 18",
            "LocationId": 519951,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 605202,
            "IsExpanded": true,
            "LinkItemId": 219436,
            "ValidationStatus": "Pending Validation"
        },
        {
            "ONRSRRef": 272009,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 5,
            "StateLabel": "Queensland",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId":3,
            "DefinedLocationTypeName": "Crossing Loop",
            "LocationName": "Crossing Loop 19",
            "LocationId": 844458,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 257791,
            "IsExpanded": true,
            "LinkItemId": 403988,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 194083,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId":3,
            "StateLabel": "Victoria",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 20",
            "LocationId": 852376,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 434507,
            "IsExpanded": false,
            "LinkItemId": 675247,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 777533,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 5,
            "DefinedLocationTypeName": "Private siding",
            "LocationName": "Private siding 21",
            "LocationId": 102843,
            "OntologyStatusId": 1,
            "OntologyStatusLabel": "Awaiting Further Information",
            "DefinedLocationId": 522702,
            "IsExpanded": false,
            "LinkItemId": 674493,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 267095,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 2,
            "StateLabel": "Northern Territory",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 22",
            "LocationId": 970380,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 778449,
            "IsExpanded": false,
            "LinkItemId": 796340,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 698858,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 23",
            "LocationId": 453574,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 308668,
            "IsExpanded": true,
            "LinkItemId": 364458,
            "ValidationStatus": "Pending Validation"
        },
        {
            "ONRSRRef": 133576,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId":3,
            "StateLabel": "Victoria",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 24",
            "LocationId": 378669,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 102530,
            "IsExpanded": true,
            "LinkItemId": 673617,
            "ValidationStatus": "Open"
        },
        {
            "ONRSRRef": 438487,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 5,
            "StateLabel": "Queensland",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 25",
            "LocationId": 753470,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 236168,
            "IsExpanded": true,
            "LinkItemId": 982794,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 371114,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 26",
            "LocationId": 151996,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 486682,
            "IsExpanded": true,
            "LinkItemId": 682143,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 920446,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 4,
            "StateLabel": "Australian Capital Territory",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 27",
            "LocationId": 602694,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 102854,
            "IsExpanded": false,
            "LinkItemId": 988134,
            "ValidationStatus": "Closed"
        },
        {
            "ONRSRRef": 908530,
            "LocationStatusId": 1,
            "LocationStatusLabel": "Non-operational",
            "StateId": 8,
            "StateLabel": "South Australia",
            "DefinedLocationStatusId": 1,
            "DefinedLocationStatusLabel": "Non-operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 1,
            "DefinedLocationTypeName": "Bridge (rail)",
            "LocationName": "Bridge (rail) 28",
            "LocationId": 476855,
            "OntologyStatusId": 2,
            "OntologyStatusLabel": "Deleted",
            "DefinedLocationId": 461384,
            "IsExpanded": true,
            "LinkItemId": 971799,
            "ValidationStatus": "Delete Requested"
        },
        {
            "ONRSRRef": 112314,
            "LocationStatusId":3,
            "LocationStatusLabel": "Operational",
            "StateId": 7,
            "StateLabel": "Tasmania",
            "DefinedLocationStatusId":3,
            "DefinedLocationStatusLabel": "Operational",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 6,
            "DefinedLocationTypeName": "Control point",
            "LocationName": "Control point 29",
            "LocationId": 851615,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 400560,
            "IsExpanded": true,
            "LinkItemId": 227918,
            "ValidationStatus": "Queried"
        },
        {
            "ONRSRRef": 753885,
            "LocationStatusId": 2,
            "LocationStatusLabel": "Decommissioned",
            "StateId": 4,
            "StateLabel": "Australian Capital Territory",
            "DefinedLocationStatusId": 2,
            "DefinedLocationStatusLabel": "Decommissioned",
            "RailInfrastructureManagerId": 555001,
            "RailInfrastructureManagerName": "Operator Rail Pty Ltd",
            "DefinedLocationTypeId": 2,
            "DefinedLocationTypeName": "Yard/Siding",
            "LocationName": "Yard/Siding 30",
            "LocationId": 712772,
            "OntologyStatusId":3,
            "OntologyStatusLabel": "Submitted",
            "DefinedLocationId": 794523,
            "IsExpanded": false,
            "LinkItemId": 205728,
            "ValidationStatus": "Delete Requested"
        }
    ];

function formatLocationId(locationId: number): string {
    return `APJ${String(locationId).padStart(5, "0").slice(-5)}`;
}

function buildLinkedLocations(idx: number, raw: RawDefinedLocation): DefinedLocationLinkedLocation[] {
    const count = (idx % 3) + 1;
    const typeRotation = ["Yard/Siding", "Bridge (rail)", "Station", "Crossing Loop"];
    const out: DefinedLocationLinkedLocation[] = [];
    for (let i = 0; i < count; i++) {
        out.push({
            RailInfrastructureManagerName: raw.RailInfrastructureManagerName,
            DefinedLocationTypeName: typeRotation[(idx + i) % typeRotation.length],
            LocationName: `${typeRotation[(idx + i) % typeRotation.length]} Link ${idx + i + 1}`,
            LocationId: `APJ${String(40000 + idx * 3 + i).padStart(5, "0")}`,
            KMPoint: (((idx * 7 + i * 3) % 1000) / 10).toFixed(2),
        });
    }
    return out;
}

function buildVersions(idx: number): DefinedLocationVersionEntry[] {
    const total = (idx % 3) + 1;
    const users = ["Sue Lappas", "John Carter", "Maria Chen", "Tom Wright"];
    const reasons = [
        "Not found in ontology data",
        "Updated location boundaries.",
        "Status change approved.",
        "Reclassification after review.",
    ];
    const out: DefinedLocationVersionEntry[] = [];
    for (let v = 1; v <= total; v++) {
        const day = String(((idx + v) % 27) + 1).padStart(2, "0");
        const month = String(((v * 2 + idx) % 12) + 1).padStart(2, "0");
        const year = 2023 + ((v + idx) % 3);
        const start = `${day}/${month}/${year}`;
        const end = v < total ? `${day}/${month}/${year + 1}` : "";
        out.push({
            version: v,
            startDate: start,
            endDate: end,
            reasonForChange: reasons[(idx + v) % reasons.length],
            createdBy: users[(idx + v) % users.length],
            createdDate: `${start} ${String(((idx * 5 + v) % 24)).padStart(2, "0")}:${String(((idx * 7 + v) % 60)).padStart(2, "0")}`,
        });
    }
    return out;
}

export class GetDefinedLocations {
    static definedLocations: DefinedLocation[] = rawDefinedLocations.map((raw, idx) => ({
        ...raw,
        LocationId: formatLocationId(raw.LocationId),
        Version: (idx % 3) + 1,
        LinkedLocations: buildLinkedLocations(idx, raw),
        Versions: buildVersions(idx),
    }));
}

export class GetDefinedLocationMetadata {
    static metadata: DefinedLocationMetadata[] = [
        {
            id: 1,
            states: [
                { text: "New South Wales", value: "New South Wales" },
                { text: "Victoria", value: "Victoria" },
                { text: "Queensland", value: "Queensland" },
                { text: "Western Australia", value: "Western Australia" },
                { text: "South Australia", value: "South Australia" },
                { text: "Tasmania", value: "Tasmania" },
                { text: "Australian Capital Territory", value: "Australian Capital Territory" },
                { text: "Northern Territory", value: "Northern Territory" },
            ],
            locationStatuses: [
                { text: "Operational", value: "Operational" },
                { text: "Non-operational", value: "Non-operational" },
                { text: "Decommissioned", value: "Decommissioned" },
            ],
            locationTypes: [
                { text: "Bridge (rail)", value: "Bridge (rail)" },
                { text: "Yard/Siding", value: "Yard/Siding" },
                { text: "Crossing Loop", value: "Crossing Loop" },
                { text: "Station", value: "Station" },
                { text: "Private siding", value: "Private siding" },
                { text: "Control point", value: "Control point" },
            ],
            railInfrastructureManagers: [
                { text: "Operator Rail Pty Ltd", value: "Operator Rail Pty Ltd" },
                { text: "Australian Rail Track Corporation Limited", value: "Australian Rail Track Corporation Limited" },
            ],
        },
    ];
}